export default __webpack_public_path__ + "static/media/pic89.40702555.jpg";